module.exports = __webpack_public_path__ + "static/media/icon-warning.fec0eb46.svg";